import {UserNotificationConstants} from "finhelper";

export const neededNotificationTypes = [
    UserNotificationConstants.TRANSFERED_STOCK,
    UserNotificationConstants.NOT_FOUND_STOCK,
    UserNotificationConstants.NOT_FOUND_MONEY_ON_DATE,
    UserNotificationConstants.ERROR_COUNT_STOCK,
    UserNotificationConstants.NEGATIVE_TRADES,
    UserNotificationConstants.TRANSFERED_TO_ZERO
];